var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.027 0H45.0499C16.8259 0 0 16.8175 0 45.0275V109.895C0 138.183 16.8259 155 45.0499 155H109.95C138.174 155 155 138.183 155 109.973V45.0275C155.077 16.8175 138.251 0 110.027 0ZM114.602 59.675L70.6377 103.618C69.5522 104.702 68.0789 105.323 66.5282 105.323C64.9774 105.323 63.5041 104.702 62.4186 103.618L40.4752 81.685C38.2265 79.4375 38.2265 75.7175 40.4752 73.47C42.7238 71.2225 46.4456 71.2225 48.6943 73.47L66.5282 91.295L106.383 51.46C108.632 49.2125 112.353 49.2125 114.602 51.46C116.851 53.7075 116.851 57.35 114.602 59.675Z",
    fill: "#4CB592"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.065a83b6ac951bd4bdc5be4ca0557c6b.svg";
export { ForwardRef as ReactComponent };